module.exports = __webpack_public_path__ + "img/electric_enabled_selected.4553e9b3.svg";